import styled from 'styled-components';

import { minWidth, units } from '@calm-web/design-system';

import { contentWrapperTabletMinHeight } from '@/components/b2b/shared/styles';
import GridWrapper from '@/components/ui/GridWrapper';

export const landingGridWrapperMobileWidth = units(44.38);
export const landingGridWrapperTabletWidth = units(63);

export const LandingGridWrapper = styled(GridWrapper)`
	margin: 0 ${units(1.25)};
	width: ${landingGridWrapperMobileWidth};
	min-height: ${units(74.38)};

	${minWidth('tablet')} {
		width: ${landingGridWrapperTabletWidth};
		min-height: ${contentWrapperTabletMinHeight};
	}

	${minWidth('desktop')} {
		margin: unset;
		width: 100%;
		min-height: unset;
	}
`;
